/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Weekday_5Inputs */

const vi_irrigation_weekday_5 = /** @type {(inputs: Irrigation_Weekday_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T6`)
};

/**

* @param {Irrigation_Weekday_5Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_weekday_5 = /** @type {((inputs?: Irrigation_Weekday_5Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Weekday_5Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_weekday_5(inputs)
});